export const handleAuthError = (error: any) => {
  const status = error.response?.status;
  const errorCode = error.response?.data?.error?.code;

  // Handle authentication errors (401) and token validation errors (403 with INVALID_TOKEN)
  // The backend returns 403 for INVALID_TOKEN, but it's still an auth error, not a permission error
  if (status === 401 || (status === 403 && errorCode === 'INVALID_TOKEN')) {
    // Only handle actual auth failures, not all 401s/403s
    const isAuthFailure =
      errorCode === 'UNAUTHORIZED' ||
      errorCode === 'MISSING_TOKEN' ||
      errorCode === 'INVALID_SESSION' ||
      errorCode === 'INVALID_TOKEN';

    if (isAuthFailure) {
      // Clear any stored token
      localStorage.removeItem('token');

      // Get current path for return URL
      const currentPath = window.location.pathname + window.location.search;
      const returnUrl = encodeURIComponent(currentPath);

      // Redirect to login with return URL
      window.location.href = `/login?returnUrl=${returnUrl}`;

      return true; // Indicates auth error was handled
    }
  }

  // Other 403 errors (permission denied like FORBIDDEN) should not trigger logout
  // Let the calling code handle them appropriately

  return false; // Not an auth error
};

export const redirectAfterLogin = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const returnUrl = urlParams.get('returnUrl');

  if (returnUrl) {
    window.location.href = decodeURIComponent(returnUrl);
  } else {
    window.location.href = '/dashboard';
  }
};

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  return !!token;
};
